import React from 'react';
import { PropTypes } from 'prop-types';
import Button from '../../componentsV2/Button/Button';
import { redirectToEditOrganization } from '../../utils/navigation';
import Breadcrumbs from '../../componentsV2/Breadcrumbs/Breadcrumbs';
import PagesHeader from '../../componentsV2/Headers/PagesHeader';
import { getRoleChecks } from '../../utils/roles';

const OrganizationPage = ({ organization, currentUserRole }) => {
  const {
    name, code, contact, contact_email: contactEmail, description, id,
  } = organization;
  const breadcrumbLinks = [
    { href: '/admin', name: 'Admin' },
    { href: `/admin/organizations/${organization.id}`, name: 'Organization' },
  ];
  const { isManager } = getRoleChecks(currentUserRole);
  return (
    <div className="w-[80%]">
      <div className="mx-2.75">
        <header>
          <Breadcrumbs links={breadcrumbLinks} />
        </header>
        <div className="flex flex-col items-center mt-2">
          <div className="w-full">
            <div className="flex justify-between items-center border-b border-vamos-blue-gray pb-2">
              <PagesHeader name="organization" label="Organization" size="h-10" wrapDivClass="py-0" />
              {/* This button should be conditional render for Manager users */}
              {isManager && (
                <Button label="Edit" size="md" className="px-6" onClick={() => redirectToEditOrganization(id)} />
              )}
            </div>
            <div className="w-full text-left mt-4">
              <div className="flex flex-row items-center gap-x-8 mb-5">
                <h3 className="font-semibold w-40">Name</h3>
                <p>{name}</p>
              </div>
              <div className="flex flex-row items-center gap-x-8 mb-5">
                <h3 className="font-semibold w-40">Short Name</h3>
                <p>{code}</p>
              </div>
              <div className="flex flex-row items-center gap-x-8 mb-5">
                <h3 className="font-semibold w-40">Contact</h3>
                <p>{contact}</p>
              </div>
              <div className="flex flex-row items-center gap-x-8 mb-5">
                <h3 className="font-semibold w-40">Contact Email</h3>
                <p>{contactEmail}</p>
              </div>
              <div className="flex flex-row items-start gap-x-8 mb-5">
                <h3 className="font-semibold w-40">Description</h3>
                <p>{description}</p>
              </div>
              <div className="flex flex-row items-center gap-x-8 mb-5">
                <h3 className="font-semibold w-40">Status</h3>
                <p>{organization.status === 1 ? 'Full account' : 'Trial account'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

OrganizationPage.propTypes = {
  organization: PropTypes.object.isRequired,
  currentUserRole: PropTypes.string.isRequired,
};

export default OrganizationPage;
